export const SOLVRAYS_LOGO = {
  DEFAULT: "https://res.cloudinary.com/dqql2wlbt/image/upload/v1732220751/solvrays-horizontal_hojc3q.png?q_auto",
  ICON: "https://res.cloudinary.com/dqql2wlbt/image/upload/v1732220751/solvrays-logo-only_ppld9j.png?q_auto"
} as const;

export const COMPANY = {
  NAME: "Solvrays",
  WEBSITE: "https://solvrays.com",
  ADDRESS: "500 West 5th Street Suite 400, Winston Salem, North Carolina, 27101",
  PHONE: {
    NUMERIC: '+1 313 765 8729',
    VANITY: '+1 313 SOLVRAY'
  }
} as const;

export const HERO_HEADLINES = [
  "Where AI Genes Meet Insurance Intelligence",
  "Unleashing the DNA of Next-Gen Insurance Operations",
  "Revolutionary AI That Adopts and Compliments Your Existing Eco-systems",
  "The Future of Insurance is Already Here",
  "Transform Legacy Systems Into Living, Breathing Intelligence"
] as const;

export const HERO_DESCRIPTIONS = [
  "Imagine AI that doesn't just automate—it <span class='text-blue-400 font-semibold'>thinks, learns, and evolves</span> with your business. Deploy 9 specialized AI genes that seamlessly integrate with your existing systems. <span class='text-emerald-400 font-semibold'>This isn't just software—it's intelligence.</span>",
  "Your insurance operations are about to get their evolutionary upgrade. Each AI gene is engineered for specific back-office challenges—from document intelligence to workflow orchestration. <span class='text-purple-400 font-semibold'>Watch legacy systems transform into living intelligence.</span>",
  "Stop ripping and replacing. Start evolving and enhancing. Solvrays AI genes integrate with your policy admin, account management, and upstream systems—<span class='text-cyan-400 font-semibold'>making everything work better together.</span>",
  "While your competitors struggle with yesterday's technology, you'll be orchestrating tomorrow's operations. Deploy on-premise or cloud, <span class='text-orange-400 font-semibold'>your data never leaves your control.</span>",
  "Transform chaotic workflows into intelligent orchestration. From document processing to task management, every AI gene works in harmony to create <span class='text-green-400 font-semibold'>your command center for insurance operations.</span>"
] as const;
